import React, { useEffect, useState } from "react";
import { DollarSign, CreditCard, Clock, Map, Mail } from "lucide-react";
import { api, money } from "@/lib/api";
import { StatusBadge } from "@/pages/admin/BookingsAdmin";

export default function Overview({ stats, goTo }) {
  const [recent, setRecent] = useState([]);
  useEffect(() => { api.get("/admin/bookings").then((r) => setRecent(r.data.slice(0, 6))).catch(() => {}); }, []);
  const cards = [
    { label: "Ingresos cobrados", value: money(stats?.revenue), Icon: DollarSign, color: "text-emerald-600 bg-emerald-50" },
    { label: "Pagos completados", value: stats?.bookings_paid ?? "-", Icon: CreditCard, color: "brand-text bg-[var(--brand)]/10" },
    { label: "Saldo por cobrar", value: money(stats?.pending_balance), Icon: Clock, color: "text-amber-600 bg-amber-50" },
    { label: "Excursiones", value: stats?.tours ?? "-", Icon: Map, color: "text-sky-600 bg-sky-50" },
    { label: "Mensajes sin leer", value: stats?.messages_unread ?? "-", Icon: Mail, color: "accent-text bg-amber-50" },
  ];
  return (
    <div className="space-y-8" data-testid="admin-overview">
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
        {cards.map(({ label, value, Icon, color }) => (
          <div key={label} className="bg-white rounded-xl p-5 shadow-sm border border-gray-100">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${color}`}><Icon className="w-5 h-5" /></div>
            <div className="text-2xl font-bold text-gray-900 mt-3">{value}</div>
            <div className="text-sm text-gray-500">{label}</div>
          </div>
        ))}
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100">
        <div className="flex items-center justify-between p-5 border-b border-gray-100">
          <h2 className="font-semibold">Últimas compras</h2>
          <button onClick={() => goTo("bookings")} className="text-sm brand-text font-medium">Ver todas</button>
        </div>
        {recent.length === 0 ? <p className="p-8 text-center text-gray-500 text-sm">Aún no hay compras.</p> : (
          <div className="divide-y divide-gray-100">
            {recent.map((b) => (
              <div key={b.id} className="p-4 flex flex-wrap items-center justify-between gap-3 text-sm">
                <div><div className="font-medium text-gray-900">{b.customer.name} <span className="text-gray-400 font-normal">· {b.code}</span></div><div className="text-gray-500">{b.items.map((i) => i.title).join(", ")}</div></div>
                <div className="flex items-center gap-3"><span className="font-semibold">{money(b.amount_paid)} <span className="text-gray-400 font-normal">/ {money(b.total)}</span></span><StatusBadge status={b.status} /></div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
